import { Entity } from "@backstage/catalog-model";
import { pageTheme } from "@backstage/theme";
import { JsonObject } from "@backstage/types";
import { Spacer } from "@internal/plugin-utilities";
import {
  Card,
  CardHeader,
  CardContent,
  makeStyles,
  Theme,
  Typography,
} from "@material-ui/core";
import React from "react";
import { InformationTooltip } from "../../InformationTooltip";

const useStyles = makeStyles((_theme: Theme) => ({
  container: {
    margin: "0 100px",
    minHeight: 300,
  },
  content: {
    textAlign: "center",
    padding: "20px",
  },
}));

interface Props {
  teams: Entity[];
}

export const TeamCarouselAllGreen: React.FC<Props> = ({
  teams,
}): JSX.Element => {
  const classes = useStyles();

  const teamDisplay = teams.map((team: Entity) => {
    return (
      <div key={`all-green-${team.metadata.name}`}>
        <Typography variant="h2" key={`all-green-${team.metadata.name}-name`}>
          {(team?.spec?.profile as JsonObject)?.displayName as string}
        </Typography>
        <Spacer
          variant="normal"
          key={`all-green-${team.metadata.name}-spacer`}
        />
      </div>
    );
  });

  const tooltip = (
    <>
      <Typography variant="h5">Teams that are all Green</Typography>
      <div>
        This section will display the teams that have no exceptional things to
        show at the OpsReview.
      </div>
    </>
  );

  const headerTitle = (
    <>
      ✅ Teams that are all Green ✅<br />
      <InformationTooltip title={tooltip} />
    </>
  );

  return (
    <Card className={classes.container}>
      <CardHeader
        title={headerTitle}
        style={{
          backgroundImage: pageTheme.apis.backgroundImage,
          backgroundSize: "cover",
          color: "white",
          textAlign: "center",
        }}
        key="all-green-header"
      />
      <CardContent className={classes.content} key="all-green-content">
        <Spacer variant="normal" />
        {teamDisplay}
      </CardContent>
    </Card>
  );
};
